import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'index',
		component: () => import("@/view/index.vue")
	},
	{
		path: '/list/:type/:id?',
		name: 'list',
		component: () => import("@/view/list.vue")
	},
	{
		path: '/detail/:type/:id',
		name: 'detail',
		component: () => import("@/view/detail.vue")
	},
	{
		path: '/search',
		name: 'search',
		component: () => import("@/view/search.vue")
	},
	// {
	// 	path: '/error',
	// 	name: 'error',
	// 	component: () => import("@/view/error.vue")
	// }
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router